const isLoggedIn = () => {
  return window._THULEDATA._Checkout.isLoggedIn;
};

const showStateField = (states) => {
  return states.length > 1;
};

const printCityName = (name) => {
    if (!name) return '';
    return window._THULEDATA._Checkout.showCityNameInCapitalLetters ? name.toUpperCase() : name;
}

export const isIOS = () => {
  let platform = navigator?.userAgent || navigator?.platform || 'unknown';

  return (
    /iPhone|iPod|iPad|iPad Simulator|iPhone Simulator|iPod Simulator/.test(platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export { isLoggedIn, showStateField, printCityName };
